import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

import type { ICardOffer, ICatergory, TCategories } from './models';

export const isEven = (index: number) => index % 2 === 0;

const getLineIndex = (n: number, countsInLine = 2) => Math.ceil(n / countsInLine);

export const isLastLine = (index: number, arr: unknown[]) => {
    const currentLine = getLineIndex(index + 1);
    const totalLines = getLineIndex(arr.length);

    return currentLine === totalLines;
};

export const getOfferTitle = (title: string) => {
    return `Расчет кредита ${title.toLowerCase()}`;
};

const byCategory = (categoryId: ICatergory['id']) => (offer: ICardOffer) =>
    offer.category.includes(categoryId);

export const groupOffersByCategory = (
    categories: TCategories,
    offers: ICardOffer[]
): Array<{ cardOffers: ICardOffer[]; category: ICatergory }> => {
    return categories.map(category => {
        const cardOffers = offers.filter(byCategory(category.id));

        return {
            category,
            cardOffers,
        };
    });
};

/* istanbul ignore next */
export function useIsSticking({ elementRef }: { elementRef: RefObject<HTMLElement> }) {
    const [isSticking, setIsSticking] = useState<boolean>(false);

    useEffect(() => {
        const stickyElement = elementRef.current;
        /** Иногда дергается при сворачивании, показываем только в развернутом положении */
        if (stickyElement) {
            const offset = stickyElement.offsetTop;

            const handleScroll = () => {
                setIsSticking(window.scrollY > offset);
            };

            window.addEventListener('scroll', handleScroll);

            // Clean up the event listener on component unmount
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, [elementRef]);

    return { isSticking };
}

export const getNotificationTitle = (
    prefix = 'Учли ваш выбор готового кредита',
    offerTitle: string,
    newLine = true
) => {
    const separator = newLine ? '\n' : ' ';

    return `${prefix}${separator}${String(offerTitle).toLowerCase()}`;
};
